import { useEffect, useState } from "react";
import { connect } from "react-redux";
import { MdArrowForwardIos } from "react-icons/md";

import CustomCalendar from "../../../common/CustomCalendar";

import { SetModalProperties } from "../../../redux/v2/utils/actions";
import { delay, parseJSON } from "../../../utils";

function HomeCalendar(props) {
    const { workoutPlan, calendar, isDesktop } = props;
    const { account } = props.User;
    const [reposition, setReposition] = useState(false);
    const [fixPosition, setFixPosition] = useState(false);
    const [selectedDate, setSelectedDate] = useState(null);
    const [selectedDateSchedule, setSelectedDateSchedule] = useState(null);
    const [pointDate, setPointDate] = useState(null);
    const onboardingDetail = account?.onboardingDetails?.[account?.onboardingDetails?.length - 1];

    useEffect(() => {
        delay(() => {
            if (!isDesktop) {
                setReposition(false);
                setFixPosition(false);
            }
        }, 200);
    }, [selectedDate]);

    useEffect(() => {
        if (onboardingDetail?.created_at) {
            setPointDate(onboardingDetail?.created_at);
        }
    }, [onboardingDetail?.created_at]);

    return (
        <div id="home-calendar-wrapper" className={`${reposition ? "hcw-reposition" : ""} ${fixPosition ? "fixed-position" : ""}`}>
            <div>
                <CustomCalendar
                    style={{ height: reposition ? "450px" : "105px" }}
                    showHeader={isDesktop ? isDesktop : reposition}
                    onboarding={false}
                    highlights={{
                        type: "week",
                        values: calendar?.highlights ? calendar?.highlights : {}
                    }}
                    plots={workoutPlan ? workoutPlan?.plots : {}}
                    calendarDates={calendar}
                    tags={{ 5: "circle-question" }}
                    onChange={(data) => {
                        setSelectedDate({ ...data?.cell });
                        setSelectedDateSchedule({ ...data?.cellData });
                        props?.setSelectedDate({ ...data?.cell });
                        props?.setSelectedDateSchedule({ ...data?.cellData });
                    }}
                    pointDate={pointDate}
                />
                <div id="home-calendar-footer">
                    {!isDesktop ? < div id="hcf-arrow-down" className="flex-c">
                        <MdArrowForwardIos onClick={() => {
                            setReposition(!reposition);
                            setFixPosition(!fixPosition);
                        }} />
                    </div> : ""}
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    SetModalProperties,
})(HomeCalendar);